import { optionValues } from 'components/helper/helper';

//#region Grade
export const gradeOptions = [
  { value: '',     name: '- Select -' },
  { value: '9th',  name: '9th' },
  { value: '10th', name: '10th' },
  { value: '11th', name: '11th'  },
  { value: '12th', name: '12th'  },
];
//#endregion

//#region Academic Year selection *
export const academicOptions = [
  { value: '- Select -' },
  { value: '2000 - 2001' },
  { value: '2001 - 2002' },
  { value: '2002 - 2003' },
  { value: '2003 - 2004' },
  { value: '2004 - 2005' },
  { value: '2005 - 2006' },
  { value: '2006 - 2007' },
  { value: '2007 - 2008' },
  { value: '2008 - 2009' },
  { value: '2009 - 2010' },
  { value: '2010 - 2011' },
  { value: '2011 - 2012' },
  { value: '2012 - 2013' },
  { value: '2013 - 2014' },
  { value: '2014 - 2015' },
  { value: '2015 - 2016' },
  { value: '2016 - 2017' },
  { value: '2017 - 2018' },
  { value: '2018 - 2019' },
  { value: '2019 - 2020' },
  { value: '2020 - 2021' },
  { value: '2021 - 2022' },
  { value: '2022 - 2023' },
  { value: '2023 - 2024' },
  { value: '2024 - 2025' },
  { value: '2025 - 2026' },
  { value: '2026 - 2027' },
  { value: '2027 - 2028' },
  { value: '2028 - 2029' },

];
//#endregion

//#region Date received or to be received
const years = {
  start: 1924,
  end: Math.max(2030, new Date().getFullYear() + 1),
};

export const receivedYears = [
  '- Select -',
  ...optionValues(
    Array.from({ length: years.end + 1 - years.start }, (_, i) => i + years.start)
  ).reverse(),
];
//#endregion
